import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail } from 'lucide-react';
import { routePages, areaPages } from '../data/seoPages';

export const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#0a0a0a] border-t border-white/10 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="/sg-cabs-logo.png" 
                alt="SG Cabs Logo" 
                className="w-16 h-16 object-contain"
              />
            </div>
            <p className="text-gray-400 mb-4 leading-relaxed">
              Premium cab services in Bangalore offering airport transfers, outstation trips, 
              and hourly rentals. Experience comfort, safety, and reliability with every ride.
            </p>
            <div className="space-y-2">
              <a href="tel:+917507867648" className="flex items-center space-x-2 text-gray-300 hover:text-[#d4af37] transition-colors">
                <Phone className="w-4 h-4" />
                <span>+91 75078 67648</span>
              </a>
              <a href="mailto:sgcabs.official@gmail.com" className="flex items-center space-x-2 text-gray-300 hover:text-[#d4af37] transition-colors">
                <Mail className="w-4 h-4" />
                <span>sgcabs.official@gmail.com</span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-base font-semibold mb-4 text-[#d4af37] uppercase tracking-[0.15em]">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('services')} className="text-gray-400 hover:text-[#d4af37] transition-colors">
                  Services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('routes')} className="text-gray-400 hover:text-[#d4af37] transition-colors">
                  Popular Routes
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('fares')} className="text-gray-400 hover:text-[#d4af37] transition-colors">
                  Fares
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('fleet')} className="text-gray-400 hover:text-[#d4af37] transition-colors">
                  Our Fleet
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-gray-400 hover:text-[#d4af37] transition-colors">
                  Contact Us
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-base font-semibold mb-4 text-[#d4af37] uppercase tracking-[0.15em]">Our Services</h3>
            <ul className="space-y-2">
              <li className="text-gray-400">Airport Transfers</li>
              <li className="text-gray-400">Outstation Trips</li>
              <li className="text-gray-400">Hourly Rentals</li>
              <li className="text-gray-400">Corporate Services</li>
              <li className="text-gray-400">City Tours</li>
            </ul>
          </div>
        </div>

        {/* SEO link clusters */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-10 pt-8 border-t border-white/10">
          <div>
            <h3 className="text-xs font-semibold mb-3 text-[#d4af37] uppercase tracking-[0.15em]">One Way Cabs</h3>
            <ul className="flex flex-wrap gap-x-4 gap-y-2" data-testid="footer-route-links">
              {routePages.filter((p) => !p.reverse).map((p) => (
                <li key={p.slug}>
                  <Link to={`/${p.slug}`} className="text-gray-400 hover:text-[#d4af37] text-sm transition-colors">Bangalore to {p.city} cab</Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="text-xs font-semibold mb-3 text-[#d4af37] uppercase tracking-[0.15em]">Airport Taxi by Area</h3>
            <ul className="flex flex-wrap gap-x-4 gap-y-2" data-testid="footer-area-links">
              {areaPages.map((a) => (
                <li key={a.slug}>
                  <Link to={`/${a.slug}`} className="text-gray-400 hover:text-[#d4af37] text-sm transition-colors">{a.name}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              © {new Date().getFullYear()} SG Cabs. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <a href="#" className="text-gray-400 hover:text-[#d4af37] text-sm transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-[#d4af37] text-sm transition-colors">
                Terms of Service
              </a>
              <a href="#" className="text-gray-400 hover:text-[#d4af37] text-sm transition-colors">
                Cancellation Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
